
	frappe.templates['search'] = `<div class="search-results flex">
	<div class="col-md-2 col-sm-3 hidden-xs layout-side-section search-shortcuts-sidebar">
		<ul class="overlay-sidebar list-unstyled search-sidebar"></ul>
	</div>
	<div class="col-md-10 col-sm-9 layout-main-section search-main-column">
		<div class="global-search-doctype-filters hide"></div>
		<div class="results-area"></div>
	</div>
</div>
`;
